import React from 'react'

const Trash = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M20 9.66667L19.0667 18.9978C18.9256 20.4122 18.8556 21.1189 18.5333 21.6533C18.2507 22.1238 17.8351 22.5 17.3389 22.7344C16.7756 23 16.0667 23 14.6444 23H12.0222C10.6011 23 9.89111 23 9.32778 22.7333C8.83116 22.4991 8.41513 22.1228 8.13222 21.6522C7.81222 21.1189 7.74111 20.4122 7.59889 18.9978L6.66667 9.66667M5 6.88889H10.1278M10.1278 6.88889L10.5567 3.92C10.6811 3.38 11.13 3 11.6456 3H15.0211C15.5367 3 15.9844 3.38 16.11 3.92L16.5389 6.88889M10.1278 6.88889H16.5389M16.5389 6.88889H21.6667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></path>
<path d="M15 16.8891V11.3335M11.6667 16.8891V11.3335" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeOpacity="0.5" strokeWidth="1.5"></path>
</svg>
    )
}

export default Trash
